import React from 'react';
import { useIntl } from 'react-intl';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { makeStyles, Tooltip } from '@material-ui/core';
import { getI18n } from "../../../utils/intl";

import { RespCodeList } from '../../../constants/customReport';

import styles from './styles';

const filterLabelMap = {
  apiId: 'Api(s)',
  apiKeyId: 'API Key(s)',
  appId: 'Application(s)',
  orgId: 'Organization(s)',
  gatewayServerId: 'Proxy(s)',
  org: 'Organizations',
  api: 'APIs',
  app: 'Applications',
  gateway: 'Gateways',
  respCode: 'Response Code(s)',
  uri: 'URI(s)',
};

const getFilterLabelsWithKey = filters => {
  let key = 0;
  const filtersWithKey = [];
  _.each(filters, filter => {
    if (filter.type !== 'default') {
      filtersWithKey.push({ ...filter, key: `filter-${key++}` });
    }
  });
  return filtersWithKey;
};

const getItemsLength = item => {
  let num;
  if (_.isUndefined(item)) {
    return num;
  }
  if (item.values) {
    num = _.keys(item.values).length;
  } else if (item.dimension === 'respCode' && item.fields) {
    num = item.fields.length;
  } else if (item.type === 'range') {
    num = item.ranges.length;
  }
  return num;
};

const getTooltipLabel = (
  item,
  dimension,
  type,
  apiList,
  apiKeyList,
  appList,
  orgList,
  gatewayList,
  intl,
) => {
  let entityName = '';
  let isFormatted = false;
  if (dimension === 'respCode') {
    if (type === 'or') {
      entityName = intl.getI18nMessage(RespCodeList[`${item.lower}-${item.upper}`].labelKey);
    } else if (type === 'range') {
      entityName = item.name;
    } else {
      entityName = item;
    }
  } else if (dimension === 'uri') {
    entityName = item.name;
  } else {
    const entityList = dimension.includes('Id')
      ? dimension.replace('Id', 'List')
      : dimension;
    const entityMap = { apiList, apiKeyList, appList, orgList, gatewayServerList: gatewayList };
    const entityListMap = entityMap[entityList];
    if (dimension === 'apiKeyId') {
      const { appName, orgName, name } = entityListMap[item] || {};
      if (orgName && appName && name) {
        isFormatted = true;
      }
      entityName = isFormatted ?
        `<b>${name}</b> (${orgName} › ${appName})`
        : (name || item);
    } else {
      entityName = entityListMap[item] ? entityListMap[item] : item;
    }
  }
  return isFormatted ?
  // eslint-disable-next-line react/no-danger
  (<div key={item} dangerouslySetInnerHTML={{ __html: entityName }} />)
  : (<div key={item}>{entityName}</div>);
};

const FilterLabel = ({
  filterLabels,
  handleClick,
  apiList,
  apiKeyDetailsMap,
  appList,
  orgList,
  gatewayList,
}) => {
  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const filters = getFilterLabelsWithKey(filterLabels);
  const getTooltip = (label) => {
      let filterLabelValues = [];
      if (label.dimension === 'respCode') {
        if (label.type === 'or') {
          filterLabelValues = label.fields;
        } else if (label.type === 'range') {
          filterLabelValues = label.ranges;
        } else if (label.type === 'in') {
          filterLabelValues = _.keys(label.values);
        }
      } else if (!Array.isArray(label.values)) {
        filterLabelValues = _.keys(label.values);
      } else {
        filterLabelValues = label.values;
      }
      return filterLabelValues.map(value =>
        getTooltipLabel(
          value,
          label.dimension,
          label.type,
          apiList,
          apiKeyDetailsMap,
          appList,
          orgList,
          gatewayList,
          intl,
        ),
      );
    };

  return (
    <div className={classes.metricTypeBox}>
      {filters.length ? (
        filters.map((label, idx) =>
          (label.limit ? (

            <div
              key={label.key}
              className={classes.filterLabelContainer}
              data-apim-test={'filter-label-container'}
              onClick={() => handleClick(label.dimensionId)}
            >
              <span>{`#Top ${label.limit} ${
                filterLabelMap[label.dimension]
              }`}</span>
              {filters.length > 1 && filters.length - 1 !== idx ? (
                <div className={classes.arrow} />
              ) : null}
            </div>
          ) : (
            <Tooltip
              arrow
              disableFocusListener
              disableTouchListener
              key={label.key}
              placement="top"
              title={getTooltip(label)}
            >
              <div
                key={label.key}
                className={classes.filterLabelContainer}
                data-apim-test={'filter-label-container'}
                onClick={() => handleClick(label.dimensionId)}
              >
                {filterLabelMap[label.dimension]}
                <div className={classes.metricCountContainer}>
                  {getItemsLength(label)}
                </div>
                {filters.length > 1 && filters.length - 1 !== idx ? (
                  <div className={classes.arrow} />
                ) : null}
              </div>
            </Tooltip>
          )),
        )
      ) : (
        <div
          className={classes.filterLabelContainer}
          onClick={() => handleClick('All Data')}
        >
          {intl.getI18nMessage('label.analytics.customReport.dashboard.filter.allData.label')}
        </div>
      )}
    </div>
  );
};

FilterLabel.propTypes= {
  filterLabels: PropTypes.array,
  handleClick: PropTypes.func,
  apiList: PropTypes.object,
  apiKeyDetailsMap: PropTypes.object,
  appList: PropTypes.object,
  orgList: PropTypes.object,
  gatewayList: PropTypes.object,
};

export default FilterLabel;